import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'visitorLog'

const initialState = {
  list: null,
  selected: null,
  badgeColor: null,
  pickupList: [],
}

const basePath = '/api/visitor-log'

export const search = createApiAction(
  'visitorLog/search',
  client.search(basePath),
)

export const get = createApiAction(
  'visitorLog/get',
  client.retrieve(`${basePath}/:id`),
)

export const save = createApiAction(
  'visitorLog/save',
  client.save(basePath),
)

export const getBadgeColor = createApiAction(
  'visitorLog/badgeColor',
  client.retrieve(`${basePath}/badge-color`),
)

export const getPickupList = createApiAction(
  'visitorLog/pickupList',
  client.retrieve(`${basePath}/pickup-list/:studentId`),
)

const updateList = (state, action) => {
  const list = state.list || []
  const found = list.find(item => item.id === action.payload.id)

  state.list = found
    ? list.map(item =>
        item.id === action.payload.id ? action.payload : item,
      )
    : [...list, action.payload]
}

const visitorLogSlice = createSlice({
  name,
  initialState,
  reducers: {
    clearPickupList: state => {
      state.pickupList = []
    },
  },
  extraReducers(builder) {
    builder
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload
      })
      .addCase(get.fulfilled, (state, action) => {
        state.selected = action.payload
      })
      .addCase(save.fulfilled, updateList)
      .addCase(getBadgeColor.fulfilled, (state, action) => {
        state.badgeColor = action.payload
      })
      .addCase(getPickupList.fulfilled, (state, action) => {
        state.pickupList = action.payload
      })
  },
})

export const { clearPickupList } = visitorLogSlice.actions

export default visitorLogSlice.reducer